module.exports = __webpack_public_path__ + "img/ic_company-logo_10.ae6d90e3.svg";